import { isSupportedAlpha2CountryCode } from '@/lib/utils/localization/isSupportedAlpha2CountryCode'
import { toAlpha3 } from '@/lib/utils/localization/toAlpha3'
import type { ExclusiveLockedContentType } from '../types/CosmicProductType'
import type { GetExclusiveContentProps } from '../../getExclusiveContent'

type GetCosmicExclusiveContentResponse = {
  exclusiveLockedContentData: ExclusiveLockedContentType
}

export const getCosmicExclusiveContent = async ({
  locale,
}: GetExclusiveContentProps) => {
  const alpha2CountryCode = locale.split('-')[1]

  if (!isSupportedAlpha2CountryCode(alpha2CountryCode)) return null

  const alpha3CountryCodeUpperCased = toAlpha3(
    alpha2CountryCode,
  ).toUpperCase() as Uppercase<ReturnType<typeof toAlpha3>>

  const url = `${process.env.NEXT_PUBLIC_COSMIC_BASE_URL}/promotion-contents/exclusives/published`
  const params = new URLSearchParams({
    publicationStatus: process.env.NEXT_PUBLIC_COSMIC_PUBLICATION_STATUS ?? '',
    locale,
    countryAlias: alpha3CountryCodeUpperCased,
    siteAlias: process.env.NEXT_PUBLIC_COSMIC_SITE_ALIAS ?? '',
  })

  const response = await fetch(`${url}?${params.toString()}`, {
    method: 'GET',
    headers: {
      accept: '*/*',
    },
  })

  if (!response.ok) {
    return {
      error: {
        message: 'Error fetching exclusive content',
      },
    }
  }

  const data = (await response.json()) as GetCosmicExclusiveContentResponse

  return data
}
